import { useState, type InputHTMLAttributes } from 'react';
import { Eye, EyeOff } from 'lucide-react';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

/**
 * Campo de contraseña con el ojo para mostrarla u ocultarla.
 *
 * Escribir a ciegas es la principal fuente de "contraseña incorrecta" en un
 * teclado con acentos o en un teléfono, y al crear una cuenta el administrador
 * necesita leer lo que va a dictar. El estado por defecto sigue siendo oculta.
 */
export function CampoPassword({ className, ...resto }: Props) {
  const [visible, setVisible] = useState(false);

  return (
    <div className="campo-password">
      <input
        {...resto}
        type={visible ? 'text' : 'password'}
        className={`input ${className ?? ''}`.trim()}
      />
      <button
        type="button"
        className="campo-password__ojo"
        onClick={() => setVisible((v) => !v)}
        title={visible ? 'Ocultar la contraseña' : 'Mostrar la contraseña'}
        aria-label={visible ? 'Ocultar la contraseña' : 'Mostrar la contraseña'}
        // Sin esto, pulsar el ojo dentro de un formulario roba el foco del
        // campo y en algunos navegadores dispara el envío.
        tabIndex={-1}
      >
        {visible ? <EyeOff size={15} /> : <Eye size={15} />}
      </button>
    </div>
  );
}
